/* eslint-disable react/jsx-props-no-spreading */
// import { paths } from 'constants/paths';
// import PrivateRoute from 'authComponents/PrivateRoute';
import React, { LazyExoticComponent } from 'react';

import { RouteConfig, RouteConfigComponentProps } from 'react-router-config';
import { generatePath as _generatePath, Route, Switch, SwitchProps } from 'react-router-dom';

// type IRouteConfig = RouteConfig & {
//     path: string;
// }
export interface EnhancedRouteConfig extends RouteConfig {
    needLogin?: boolean; // 是否需要登陆
    // path: (string | string[]) & (H.LocationDescriptor<unknown> | H.Location<unknown>);
    // key?: string;
    path: string;
    routes?: EnhancedRouteConfig[];
    component?:
        | React.ComponentType<RouteConfigComponentProps<any>>
        | React.ComponentType
        | LazyExoticComponent<React.FC<any>>;
}

export function renderRoutes(
    routes: EnhancedRouteConfig[] | undefined,
    extraProps: any = {},
    switchProps: SwitchProps = {},
) {
    return routes ? (
        <Switch {...switchProps}>
            {routes.map((route, index) => {
                return (
                    <Route
                        key={route.key ?? index}
                        path={route.path}
                        exact={route.exact}
                        strict={route.strict}
                        render={(props) => {
                            window.scrollTo(0, 0); // 滚动条滚动回首页
                            if (route.render) {
                                return route.render({ ...props, ...extraProps, route });
                            }
                            if (route.component) {
                                return (
                                    <route.component
                                        key={route.key ?? index}
                                        {...props}
                                        {...extraProps}
                                        route={route}
                                    />
                                );
                            }
                            return null;
                        }}
                    />
                );
            })}
        </Switch>
    ) : null;
}

// generate('/:id', {id: 1})
// output: /1
export function generatePath(...params: Parameters<typeof _generatePath>): string {
    return _generatePath(...params);
}

// 重定向 优先级如下:
// 1. location.state.from.pathname
// 2. url?redirectUrl=
// 3. paths.INDEX.path
export function useRedirect() {
    // const history = useHistory();
    // const location = useLocation<{ from: Location }>();
    // const redirectUrl = useMemo(() => {
    //     if (location.state?.from?.pathname) {
    //         return location.state.from.pathname;
    //     }
    //     const query = qs.parse(location.search.substring(1));
    //     if (typeof query.redirectUrl === 'string') {
    //         return query.redirectUrl;
    //     }
    //     return paths.INDEX.path;
    // }, [location]);
    // 一律重定向到开户页，开户页判定是否已开户
    // const redirectUrl = paths.CREATE_ACCOUNT.path;
    // return useCallback(() => {
    //     history.replace(redirectUrl);
    // }, [history, redirectUrl]);
}

export function openTab(path: string) {
    window.open(`${window.location.origin}${window.location.pathname}${window.location.search ?? ''}#${path}`);
}
